// @owners { team: patients }
import { useQuery } from '@tanstack/react-query';
import getShowProgynySelfServiceForUser from '~shared/features/users/selectors/getShowProgynySelfServiceForUser';
import { queries } from '~shared/queries/query-keys';
import { useSelectorShared } from '~shared/store';
import { onboardingBackgroundColor } from '../helpers/onboardingBackgroundColor';

export const useQueryInsuranceConfigs = () => {
  const showProgyny = useSelectorShared(getShowProgynySelfServiceForUser);

  const { isFetching, isError, isSuccess, data } = useQuery({
    ...queries.onboardingConfigs.fetchInsurance({ params: {} }),
  });

  const partnershipName = data?.data?.partnership_name;
  const headerBackgroundColor = onboardingBackgroundColor(partnershipName, showProgyny);

  return {
    headerBackgroundColor,
    headerLogoUrl: data?.data?.header_logo_url,
    isFetching,
    isError,
    isSuccess,
    partnershipName,
  };
};
